import { Injectable } from '@angular/core';

@Injectable()
export class PageService {
  currentPage: number = 1;

  CurrentPageNumber(pageNr: number) {

    this.currentPage = pageNr;
  };

}
